import React, {Fragment, useContext, } from 'react';
import {Container, Segment, Header, Button, Image} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { RootStoreContext } from '../../App/stores/RootStore';
import { useMsal} from "@azure/msal-react";

const HomePage = () => {
  const { instance, accounts } = useMsal();
  const rootStore = useContext(RootStoreContext);

  return (
    <Segment inverted textAlign='center' vertical className='masthead'>
      <Container text>
        <Header as='h1' inverted>
          <Image
            size='massive'
            src='/assets/URD_Icon.png'
            alt='logo'
            style={{ marginBottom: 12 }}
          />
          User Registration Database
        </Header>


        { (accounts.length > 0)
          ? (
            <Fragment>
              <Header as='h2' inverted content={`welcome back ${accounts[0].name?? ""}`} />

              <Button onClick={() => instance.logout()} size='huge' inverted>
                Log Out
              </Button>
              <Button as={Link} to='/requests' size='huge' inverted>
                Continue to requests
            </Button>
            </Fragment>
          ) : (
            <Fragment>
              <Header as='h2' inverted content={`Welcome to the User Registration Database`} />
              <Button onClick={() => instance.loginRedirect()} size='huge' inverted>
                Log In
          </Button>
            </Fragment>
          )
        }

      </Container>
    </Segment>
  );
};

export default HomePage;
